import { shape, string, bool, node, oneOf, oneOfType, object, func, number } from 'prop-types';
import { MARKER_TYPE } from '../../constants/Values';

export default shape({
  infoContent: oneOfType([
    shape({
      fullInformation: node.isRequired,
      routeInformation: node.isRequired,
    }).isRequired,
    node.isRequired,
  ]),
  markerIcon: oneOfType([string.isRequired, object.isRequired]),
  isPositionActual: bool,
  showInfo: oneOfType([
    shape({
      content: bool.isRequired,
      route: bool.isRequired,
    }).isRequired,
    bool.isRequired,
  ]),
  position: shape({
    equals: func,
    lat: oneOfType([func, number]),
    lng: oneOfType([func, number]),
    toJSON: func,
    toString: func,
    toUrlValue: func,
  }).isRequired,
  type: oneOf(Object.values(MARKER_TYPE)),
  markerId: string,
});
